module.exports = __webpack_public_path__ + "img/hero-bg.5f87904b.jpg";